import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import ContactHelp from "shared/components/SVG/LMF/ContactHelp";
import HelpModal from "./HelpModal";
import Progress from "./Progress";
import Logo from "./svg/lmf-logo.svg";

const Header = ({
  progressValue,
  View,
  help,
  setHelp,
  helpText,
  contact,
  isMobile,
  onSubmit,
  project,
}) => {
  const [openHelp, setOpenHelp] = useState(false);
  const isMobileQuery = useMediaQuery({ maxWidth: 768 });
  const isMobileDevice = isMobile || isMobileQuery;

  return (
    <>
      <div className="navbar__lmf">
        <div className="navbar__lmf--row">
          <img src={Logo} alt="LMF logo" className="logo" />
          <div className="navbar__lmf--actions">
            {isMobileDevice && help && (
              <ContactHelp
                size={isMobile ? 24 : 40}
                onClick={() => setOpenHelp(true)}
              />
            )}
            {View}
          </div>
        </div>
        <Progress value={progressValue} />
      </div>

      <HelpModal
        open={openHelp}
        setOpen={setOpenHelp}
        contact={contact}
        onSubmit={onSubmit}
        project={project}
      />
    </>
  );
};

export default Header;
